import { FC, useContext, useEffect } from "react";
import { Layout, ParseLine } from "../components";
import logo from "../assets/logo.svg";
import { useNavigate } from "react-router-dom";
import { Context } from "..";
import styled from "styled-components";
import { Link as Href } from "react-router-dom";
import { observer } from "mobx-react";

const Link = styled(Href)`
  text-decoration: none;
  color: #1a4fe0;
  :hover {
    color: blue;
    text-decoration: underline;
  }
`;

const AdminPage: FC<{ title: string }> = observer(({ title }) => {
  const navigate = useNavigate();
  const { store } = useContext(Context);
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
    if(store.user.type !== "admin") return navigate(`/${store.user.type}`);
  }, [navigate, store.isAuth, store.user.type]);

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={120} height={120} />
      <Link to="/admin/master/create">Добавить мастера</Link>
      <Link to="/admin/master/edit">Изменить мастера</Link>
      <Link to="/admin/master/delete">Удалить мастера</Link>
      <ParseLine />
      <Link to="/admin/service/create">Добавить услугу</Link>
      <Link to="/admin/service/edit">Изменить услугу</Link>
      <Link to="/admin/service/delete">Удалить услугу</Link>
      <ParseLine />
      <Link to="/admin/product/create">Добавить продукт</Link>
      <Link to="/admin/product/edit">Изменить продукт</Link>
      <Link to="/admin/product/delete">Удалить продукт</Link>
      <ParseLine />
      <Link to="/admin/stat/today">Статистика за сегодня</Link>
      <Link to="/admin/stat/month">Статистика за месяц</Link>
      <Link to="/admin/stat/all">Статистика за всё время</Link>
      <Link to="/admin/stat/reports">Сохраненные отчеты</Link>
    </Layout>
  );
});

export default AdminPage;
